<nz-form-item class="!mb-0">
  <nz-form-control
  [nzValidateStatus]="ngControl.control ?? ''"
  [nzErrorTip]="errorTpl"
  [nzExtra]="helperTpl">
      <nz-select
        [nzPlaceHolder]="label"
        nzShowSearch nzAllowClear
        [nzDisabled]="disabled"
        (onTouched)="onTouched()" [ngModel]="value"
        (ngModelChange)="value = $event; onChange($event); onTouched()">
        <nz-option *ngFor="let opt of options" [nzValue]="opt.id" [nzLabel]="opt.name"></nz-option>
      </nz-select>
  </nz-form-control>
</nz-form-item>

<ng-template #iconSelect><fa-icon [icon]="icons.falAnglesUpDown"></fa-icon></ng-template>

<ng-template #errorTpl>
  <ng-container *ngIf="showError">
    <span *ngFor="let err of ngControl?.control?.errors | keyvalue">
      {{ errorMessages[err.key] || err.key }}
    </span>
  </ng-container>
</ng-template>

<ng-template #helperTpl>
  <span *ngIf="showHelper">
    {{ helperText }}
  </span>
</ng-template>
